require('angulartics');
require('angular-dnd-lists');
'use strict';

angular
  .module('amexReconciliationApp', [
    'ngAnimate',
    'ngFileUpload',
    'ngResource',
    'ui.select',
    'ngSanitize',
    'pascalprecht.translate',
    'toastr',
    'translateProviderConfig',
    'ui.bootstrap',
    'ui.scrollpoint',
    'ui.router',
    'angulartics',
    'dndLists',
    require('./modules/angulartics-amex-adobe-analytics')
  ])
  .config(function ($stateProvider,
    $urlRouterProvider,
    $urlMatcherFactoryProvider,
    $uibModalProvider) {

    $uibModalProvider.options.windowTemplateUrl = 'scripts/views/modals/window-template.html';
    $uibModalProvider.options.backdropClass = 'recon-modal-backdrop';

    $urlMatcherFactoryProvider.strictMode(false);

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('error', {
        url: '/error',
        template: '<h1> ERROR </h1>'
      })
      .state('home', {
        url: '',
        onEnter: function ($state,
          InitService,
          UserModel,
          TransactionSearchModel,
          TimeoutWarningModalService,
          roles,
          AdobeAnalyticsService,
          $uibModal,
          $window) {
          InitService.init().then(function () {
            if (!UserModel.currentUser()) {
              return;
            }

            var roleNames = _.flatMap(UserModel.roles(), function (role) { return role.name; });
            var hasBcaRole = _.includes(roleNames, roles.BCA_MANAGER) || _.includes(roleNames, roles.LIMITED_BCA_MANAGER);
            var hasCardManager = _.includes(roleNames, roles.CARD_MANAGER) || _.includes(roleNames, roles.LIMITED_CARD_MANAGER);
            var hasAccountingManager = _.includes(roleNames, roles.ACCOUNTING_MANAGER) || _.includes(roleNames, roles.LIMITED_ACCOUNTING_MANAGER);
            var hasCardMember = _.includes(roleNames, roles.CARDMEMBER) || _.includes(roleNames, roles.LIMITED_CARDMEMBER);
            var hasBTAManager = _.includes(roleNames, roles.BTA_MANAGER);

            var isMobile = $window.innerWidth < 768;


            if (isMobile) {
              if (hasCardMember) {
                $state.go('cardmember');
              } else if (hasCardManager) {
                $state.go('cardManager');
              } else if (hasBcaRole) {
                $state.go('bcaManager');
              } else if (hasAccountingManager) {
                $state.go('accountingManager');
              } else if (hasBTAManager) {
                $state.go('btaManager');
              } else {
                $state.go('noRole');
              }
            } else {
              if (hasBcaRole) {
                $state.go('bcaManager');
              } else if (hasCardManager) {
                $state.go('cardManager');
              } else if (hasAccountingManager) {
                $state.go('accountingManager');
              } else if (hasCardMember) {
                $state.go('cardmember');
              } else if (hasBTAManager) {
                $state.go('btaManager');
              } else {
                $state.go('noRole');
              }
            }
          });
        }
      })
      .state('bcaManager', {
        url: '/bcaManager',
        template: '<bca-accounts-list></bca-accounts-list>',
        resolve: {
          activeUser: function (InitService) {
            return InitService.init();
          }
        },
        onEnter: function (TransactionSearchModel, roles, UserModel) {
          var managerRole = _.find(
            UserModel.currentUser().roles, function (role) {
              return role.name === roles.BCA_MANAGER
                || role.name === roles.LIMITED_BCA_MANAGER;
            });
          TransactionSearchModel.role(managerRole);
        }
      })
      .state('cardManager', {
        url: '/cardManager',
        template: '<card-accounts-list></card-accounts-list>',
        resolve: {
          activeUser: function (InitService) {
            return InitService.init();
          }
        },
        onEnter: function (TransactionSearchModel, roles, UserModel) {
          var managerRole = _.find(
            UserModel.currentUser().roles, function (role) {
              return role.name === roles.CARD_MANAGER
                || role.name === roles.LIMITED_CARD_MANAGER;
            });
          TransactionSearchModel.role(managerRole);
        }
      })
      .state('cardmember', {
        url: '/cardmember',
        template: '<card-accounts-list></card-accounts-list>',
        resolve: {
          activeUser: function (InitService) {
            return InitService.init();
          }
        },
        onEnter: function (TransactionSearchModel, roles, UserModel) {
          var role = _.find(
            UserModel.currentUser().roles, function (role) {
              return role.name === roles.CARDMEMBER
                || role.name === roles.LIMITED_CARDMEMBER;
            });
          TransactionSearchModel.role(role);
        }
      })
      .state('accountingManager', {
        url: '/accountingManager',
        template: '<accounting-manager-accounts-list></accounting-manager-accounts-list>',
        resolve: {
          activeUser: function (InitService) {
            return InitService.init();
          }
        },
        onEnter: function (TransactionSearchModel, roles, UserModel) {
          var managerRole = _.find(UserModel.currentUser().roles, function (role) {
            return role.name === roles.ACCOUNTING_MANAGER
              || role.name === roles.LIMITED_ACCOUNTING_MANAGER;
          });
          TransactionSearchModel.role(managerRole);
        }
      })
      .state('btaManager', {
              url: '/btaManager',
              template: '<bta-account-list></bta-account-list>',
              resolve: {
                activeUser: function (InitService) {
                  return InitService.init();
                }
              }
            })
      .state('noRole', {
        url: '/noRole',
        template: '<no-role></no-role>',
        resolve: {
          activeUser: function (InitService) {
            return InitService.init();
          }
        }
      })
      .state('transactions', {
        url: '/:currentRole/transactions',
        reloadOnSearch: true,
        stateTitle: 'transactions.Transactions',
        template: '<transaction-list-container></transaction-list-container>',
        resolve: {
          activeUser: function (InitService) {
            return InitService.init();
          }
        },
        onEnter: function (TransactionService, // jshint ignore:line
          TimeoutWarningModalService, // jshint ignore:line
          ActiveTransactionModel,
          SiteConfigModel,
          AnalyticsService) {
          AnalyticsService.trackTransactionListViewed();
          ActiveTransactionModel.clearActiveTransaction();
          SiteConfigModel.siteConfig(); // to ensure SiteConfigModel is initialized for first SiteNumber change.
        }
      })
      .state('transactions.overview', {
        abstract: true,
        url: '/?index&transactionId',
        resolve: {
          activeTransaction: function (ActiveTransactionModel, $stateParams) {
            return ActiveTransactionModel.setActiveTransactionId(parseInt($stateParams.transactionId));
          }
        },
        views: {
          '@': {
            template: '<transactions-overview></transactions-overview>'
          }
        }
      })
      .state('transactions.overview.allocations', {
        url: '^/:currentRole/allocations',
        stateTitle: 'allocations.Reallocate',
        template: '<allocations allocations="$resolve.allocations"></allocations>',
        resolve: {
          allocations: function (activeTransaction, ActiveTransactionAllocationsService) {
            if (activeTransaction) {
              return ActiveTransactionAllocationsService.fetchAllocations(activeTransaction);
            }
          }
        },
        onEnter: function (AnalyticsService) {
          AnalyticsService.trackAccountingTabViewed();
        }
      })
      .state('transactions.overview.transaction-details', {
        url: '^/:currentRole/transaction-details',
        template: '<transaction-details-data-panel taxes="$resolve.taxes"></transaction-details-data-panel>',
        resolve: {
          taxes: function (activeTransaction, TransactionTaxesRepository) {
            if (activeTransaction) {
              return TransactionTaxesRepository.fetchTaxes(activeTransaction);
            }
          }
        },
        onEnter: function (AnalyticsService) {
          AnalyticsService.trackTransactionDetailsTabViewed();
        }
      })
      .state('transactions.overview.merchant-info', {
        url: '^/:currentRole/merchant-info',
        template: '<merchant-info merchant="$resolve.merchant"></merchant-info>',
        resolve: {
          merchant: function (activeTransaction, MerchantInfoRepository) {
            if (activeTransaction) {
              return MerchantInfoRepository.fetchMerchantInfo(activeTransaction)
                .then(function (response) {
                  return response.toJSON();
                });
            }
          }
        }
      })
      .state('transactions.overview.comments', {
        url: '^/:currentRole/comments',
        template: '<additional-data additional-transaction-data="$resolve.additionalTransactionData"></additional-data>',
        resolve: {
          additionalTransactionData: function (activeTransaction, AdditionalTransactionDataRepository) {
            if (activeTransaction) {
              return AdditionalTransactionDataRepository.findAdditionalTransactionData(activeTransaction);
            }
          }
        }
      })
      .state('transactions.overview.preauth-data', {
        url: '^/:currentRole/preauth-data',
        template: '<preauth-data-panel></preauth-data-panel>'
      })
      .state('transactions.overview.meeting360-details', {
        url: '^/:currentRole/meetings360-data',
        template: '<meetings360-data-panel></meetings360-data-panel>'
      })
      .state('transactions.overview.purchase-order-details', {
        url: '^/:currentRole/purchase-order-details',
        template: '<purchase-order-details-data-panel></purchase-order-details-data-panel>'
      })
      .state('transactions.overview.travel-data', {
        url: '^/:currentRole/travel-data',
        template: '<travel-data-panel></travel-data-panel>'
      })
      .state('transactions.overview.history', {
        url: '^/:currentRole/history',
        template: '<transaction-history-list history-records="$resolve.historyRecords"></transaction-history-list>',
        resolve: {
          historyRecords: function (activeTransaction, TransactionHistoryRepository) {
            if (activeTransaction) {
              return TransactionHistoryRepository.getTransactionHistory(activeTransaction).then(function (historyRecords) {
                return historyRecords;
              });
            }
          }
        }
      })
      .state('transactions.overview.receipts', {
        url: '^/:currentRole/receipts',
        template: '<transaction-receipts></transaction-receipts>',
        resolve: {
          receipts: function (activeTransaction, TransactionReceiptService, ActiveTransactionModel) {
            if (activeTransaction) {
              return TransactionReceiptService.getReceipts(activeTransaction).then(function (receipts) {
                ActiveTransactionModel.receipts(receipts);
              });
            }
          }
        }
      });
  })
  .config(function (toastrConfig) {
    angular.extend(toastrConfig, {
      toastClass: 'alert',
      iconClasses: {
        error: 'alert-danger',
        info: 'alert-info',
        success: 'alert-success',
        warning: 'alert-warning'
      },
      closeButton: true,
      newestOnTop: false,
      timeOut: 8000
    });
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/app.js
// module id = 422
// module chunks = 0